import { DynamicText } from "@/components/DynamicText";
import { DynamicHtml } from "@/components/DynamicHtml";
import { Button } from "react-bootstrap";
import { getRoute } from "@/routes";
import classes from "./styles.module.scss";
import clsx from "classnames";
import image from "./image.png";

export const AskExpertsAside = () => {
  return (
    <aside className={clsx(classes.aside)} style={{ backgroundImage: `url(${image})` }}>
      <DynamicText path="aside.ask.experts.title" tag="h4" className="mb-3">
        Have a question?
      </DynamicText>
      <DynamicHtml path="aside.ask.experts.text" className="mb-4">
        Wanting to find out more? <br /> Have a question you want
      </DynamicHtml>
      <Button variant="blue" href={getRoute("contact")}>
        <DynamicText path="aside.ask.experts.button.label">Ask our Experts</DynamicText>
      </Button>
    </aside>
  );
};
